import colors from '@rewardopl/styles/colors';

import { toShortId } from '@rewardopl/utils/short_id';

import { CodeWrapper, ShortId, Wrapper } from './code.styles';

import Barcode from './barcode';

type CodeProps = {
  color?: string;
  displayShortId?: boolean;
  id: string;
};

export default function Code({ color, displayShortId = true, id }: CodeProps) {
  const shortId = toShortId(id);

  return (
    <Wrapper>
      <CodeWrapper>
        <Barcode bgColor={colors.white} fgColor={color} value={shortId} />
        {displayShortId ? <ShortId>{shortId}</ShortId> : null}
      </CodeWrapper>
    </Wrapper>
  );
}
